<script setup lang="ts"></script>

<template>
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    data-slot="icon"
    aria-hidden="true"
    class="color-[#51a2ff] w-5 h-5"
  >
    <path
      d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z"
      clip-rule="evenodd"
      fill-rule="evenodd"
    ></path>
  </svg>
</template>
